module.exports = __webpack_public_path__ + "img/user_active.dc9bc4d8.png";